import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import ElementUI from 'element-ui'
import http from './utils/axios'
import i18n from './i18n'
import 'element-ui/lib/theme-chalk/index.css';
import FBSignInButton from 'vue-facebook-signin-button'
 
Vue.use(FBSignInButton)
Vue.use(ElementUI);
Vue.config.productionTip = false
Vue.prototype.$http = http

new Vue({
  router,
  store,
  i18n,
  render: h => h(App)
}).$mount('#app')
